import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// Import Google Fonts - Inter (modern, clean, free font)
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import 'bootstrap-icons/font/bootstrap-icons.css'
// Custom Bootstrap variable overrides (must be imported after bootstrap.css)
import './assets/css/bootstrap-override.css'
import './assets/css/custom.css'
import api from './plugins/axios'
import './registerServiceWorker'
import {LoadingPlugin} from 'vue-loading-overlay';
// import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue-loading-overlay/dist/css/index.css';
import { createPinia } from 'pinia'
import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css';
// import axios from "axios";

// axios.get("https://pay3.tresor.gouv.ci/depense/stats_depense/public/api/transactions_system?begin_date=2025-04-02&status=success&group_id&system_user_id",
//   {
//     "headers": {
//       "Authorization": "Bearer 539|LjWxMmv8ve1kYmAVYlPiMyEyPh7c6uzSa8LnJ9Vv"
//     }
//   }
// )
// .then(response => {  console.log('API Response:', response.data);
// })
// .catch(error => {
//   console.error('API Error:', error);
// });


const app = createApp(App)
app.config.globalProperties.$api = api
app.config.globalProperties.$swal = Swal
app.config.globalProperties.$toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
});
app.use(router)
app.use(LoadingPlugin)
app.use(createPinia())
app.mount('#app')
